import React from 'react'
import classNames from 'classnames'
import Tooltip from 'components/Tooltip'
import Text from 'components/Text'
import getDebtLogo from 'components/DebtGroup/getDebtLogo'
import useMediaQuery from 'hooks/useMediaQuery'
import './DebtGroupHeader.scss'

const DebtGroupHeader = ({ group, tooltip }) => {
  const debtLogo = getDebtLogo(group?.walletId)
  const isMobile = useMediaQuery('mobile')

  const groupNameLength = group?.name?.length > 7

  const tooltipPosition =
    groupNameLength && isMobile ? 'bottom center' : 'bottom left'

  return (
    <div
      className={classNames('debt-group-header', {
        'debt-group-header--small': groupNameLength,
      })}
    >
      {debtLogo && (
        <img
          src={`/images/debts-logos/logo-${debtLogo}.svg`}
          className="debt-group-header__logo"
          width={32}
          height={32}
          alt={`Logo ${debtLogo}`}
        />
      )}
      <Text
        p
        size={11}
        className="debt-group-header__name"
        data-test="debt-group-name"
      >
        {group?.name}
      </Text>
      {tooltip && (
        <Tooltip
          iconId="iconTooltip"
          title={tooltip?.title}
          description={tooltip?.description}
          accessibleTooltipId={group?.id}
          position={tooltipPosition || tooltip?.position}
        />
      )}
    </div>
  )
}

export default DebtGroupHeader
